import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = "Komorebi - Professional Color Palette Generator | 14+ Industry Standards | Free Tool",
  description = "Professional color palette generator with 14+ industry standards (RAL, Pantone, HKS, NCS, Munsell). Built-in WCAG accessibility checker, color blindness simulation, and instant exports to CSS, Tailwind, SCSS, JSON. Free, no signup required.",
  canonical = "https://ko-mo-re-bi.com/",
  ogImage = "https://ko-mo-re-bi.com/og-image.jpg",
  ogType = "website",
  keywords = "color palette generator, RAL colors, Pantone matching, color accessibility, WCAG contrast, color blindness simulator, design tools, color standards, HKS colors, NCS colors, Munsell, Tailwind CSS, color picker, professional color tool",
  twitterCard = "summary_large_image",
  article = null // { publishedTime, modifiedTime, author }
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Canonical URL */}
      <link rel="canonical" href={canonical} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:secure_url" content={ogImage} />

      {article && (
        <>
          <meta property="article:published_time" content={article.publishedTime} />
          <meta property="article:modified_time" content={article.modifiedTime} />
          {article.author && <meta property="article:author" content={article.author} />}
        </>
      )}

      {/* Twitter */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:url" content={canonical} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;
